/**
 * @fileoverview A function for getting completed verifications from Google, to check
 * if a given entity is already verified.
 *
 * @author Kuber Sethi (ksethi@yext.com)
 */

import Uri from 'goog:goog.Uri';
import json from 'goog:goog.json';

import {Routes} from '/src/com/yext/listingslaunchstorm/js/routes';

import {doRequest} from '/src/com/yext/listingslaunchstorm/js/common/util/dorequest';
import {GetCompletedVerificationRequest} from '/src/com/yext/listingslaunchstorm/js/data/getcompletedverificationrequest';
import {GetCompletedVerificationResponse} from '/src/com/yext/listingslaunchstorm/js/data/getcompletedverificationresponse';
import {ResponseError} from '/src/com/yext/listingslaunchstorm/js/data/responseerror';

/**
 * @param {!GetCompletedVerificationRequest} request
 * @param {AbortSignal} abortSignal
 * @return {!Promise<ResponseError<GetCompletedVerificationResponse>>}
 */
const getCompletedVerification = (request, abortSignal) => {
  const uri = new Uri(Routes.getCompletedVerification());
  return doRequest('getCompletedVerification', abortSignal, uri, 'POST', request)
    .then(response => ResponseError.fromJSON(response, GetCompletedVerificationResponse.fromJSON));
};

export default getCompletedVerification;
